<script>
export default {
  data () {
    return {
      deprecatedMixin: {
        alternativeComponent: null
      }
    }
  },
  created () {
    var message = `${this.$options.name} component has been deprecated.`
    if (this.deprecatedMixin?.alternativeComponent) {
      message += ` Use ${this.deprecatedMixin?.alternativeComponent} instead.`
    }
    console.warn(message)
  }
}
</script>
